import axios from "axios";
import { PRODUCTS_API_BASE_URL } from "../constants";
import { ProductsQueryParams } from "../types";

export async function getAllProductsGroupedByCategory(
  lang: string,
  country: string,
  promo: string = ""
) {
  let params: ProductsQueryParams = {
    lang: lang,
    country: country,
  };
  if (promo !== "") {
    params.promo = promo;
  }
  return await axios.get(`${PRODUCTS_API_BASE_URL}categories/all/`, {
    params,
  });
}

export async function getClubProducts(
  lang: string,
  country: string,
  promo: string = ""
) {
  let params: ProductsQueryParams = {
    lang: lang,
    country: country,
  };
  if (promo !== "") {
    params.promo = promo;
  }
  return await axios.get(
    `${PRODUCTS_API_BASE_URL}/?ids=53123,53252,53102,52074&lang=es&country=ES`,
    {
      params,
    }
  );
}

export async function getFullCatalog(
  lang: string,
  country: string,
  promo_code: string = ""
) {
  let response = await getAllProductsGroupedByCategory(
    lang,
    country,
    (promo_code = "")
  );
  if (response.status === 200) {
    let categories: any = {
      65: [],
      66: [],
      67: [],
      80: [],
      90: [],
      91: [],
    };
    let productsSlugs: any = {};
    let categoryMap = response.data.categories;
    let products = response.data.products;

    for (let i = 0; i < products.length; i++) {
      let product = products[i];

      if (categoryMap["65"].includes(product["id"])) {
        categories[65].push(product);
      }
      if (categoryMap["66"].includes(product["id"])) {
        categories[66].push(product);
      }
      if (categoryMap["67"].includes(product["id"])) {
        categories[67].push(product);
      }
      if (categoryMap["80"].includes(product["id"])) {
        categories[80].push(product);
      }
      if (categoryMap["90"].includes(product["id"])) {
        categories[90].push(product);
      }
      if (categoryMap["91"].includes(product["id"])) {
        categories[91].push(product);
      }

      productsSlugs[product.translation.slug] = product;
    }
    return {
      categories: categories,
      products: productsSlugs,
    };
  }
}
